module.exports = __webpack_public_path__ + "fonts/fontello.36d4af80.woff";